import { createRoutine } from 'redux-saga-routines';

export const fetchItemsAndPackagesSkus = createRoutine(
  'FETCH_INVENTORY_ITEMS_AND_PACKAGES_SKUS'
);
